export const MenuItems = [
    {
        title: 'CONNECT WITH IBM-Watson Assistent',
        url: 'https://web-chat.global.assistant.watson.cloud.ibm.com/preview.html?region=us-south&integrationID=93b52129-7634-4551-8881-ba8b4e293235&serviceInstanceID=f72e4303-ed83-4bc4-bbb2-9f6900f8e619',
        cName: 'nav-links'
    },
    /*{
        title: 'CREATE',
        url: '#',
        cName: 'nav-links'
    },
    {
        title: 'EDITOR',
        url: '#',
        cName: 'nav-links'
    },
    {
        title: 'CONTACT US',
        url: '#',
        cName: 'nav-links'
    },
    {
        title: 'Sign Up',
        url: '#',
        cName: 'nav-links-mobile'
    },*/
]